<pas-tabset (tabChange)="onChangingTab($event)">
  <pas-tab [id]="recourseCampaignOverviewTab">
    <ng-template pasTabTitle>
      <b>{{ 'RECOURSE_CAMPAIGN_OVERVIEW_TAB' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-tva-custom-selection></app-tva-custom-selection>
      <br />
      <div id="grid-wrapper" style="width: 100%; height: 100%">
        <ag-grid-angular
          [domLayout]="'normal'"
          [style.height]="campaignsOverviewData.length > 20 ? '740px' : 'none'"
          [gridOptions]="gridOptions"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [pagination]="false"
          [multiSortKey]="multiSortKey"
          [getContextMenuItems]="getContextMenuItems"
          [tooltipShowDelay]="tooltipShowDelay"
          [enableBrowserTooltips]="true"
          [excelStyles]="excelStyles"
          [components]="frameworkComponents"
          (gridReady)="onGridReady($event)"
          class="ag-theme-alpine_customize"></ag-grid-angular>
      </div>
    </ng-template>
  </pas-tab>
  <pas-tab [id]="recourseCampaignEditTab" [disabled]="detailsTabDisabled" [hidden]="detailsTabHidden">
    <ng-template pasTabTitle>
      <b>{{ 'CAMPAIGN_DETAILS' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <recourse-campaign-details
        (onBtnRecourseCampaignEditCancel)="onBtnRecourseCampaignEditCancel()"
        (onCheckRecourseCampaignEditAssignedPerson)="
          onCheckRecourseCampaignEditAssignedPerson()
        "></recourse-campaign-details>
    </ng-template>
  </pas-tab>
</pas-tabset>

@if (detailsTabDisabled) {
  <pas-sidebar-holder [hasNavbar]="true">
    <div class="sidebar-contents">
      <ng-container>
        <div class="sidebar-element sidebar-row">
          <ul class="navbar-nav">
            <li [ngClass]="isCreateExcelRecourseCampaignEnabled ? 'nav-item' : 'nav-item disabled'">
              <a (click)="onBtnCreateExcelRecourseCampaign()" class="nav-link link-sidebar">
                <i class="material-icons">get_app</i>
                <span class="hidden-md-down" ui-test-id="excelExportBtn ">{{ 'EXCEL_EXPORT' | translate }}</span>
              </a>
            </li>
            <app-tva-custom-sidebar
              [numberOfButtonsVisibleSidebar]="numberOfButtonsVisibleSidebar"></app-tva-custom-sidebar>
          </ul>
        </div>
      </ng-container>
    </div>
  </pas-sidebar-holder>
}
